// CSV export for the ledger — admin download for accounting hand-off.
// Pure function so we can unit-test the formatting and run it on either
// the browser side or in an Edge Function.

import type { Charge } from './types';

export interface LedgerRow {
  charge: Charge;
  family_name: string;
  dancer_name: string | null;
  allocated_cents: number;
}

const HEADERS = [
  'charge_id',
  'created_at',
  'family',
  'dancer',
  'category',
  'description',
  'amount_cents',
  'allocated_cents',
  'remaining_cents',
  'due_date',
  'status',
  'stripe_invoice_id',
  'stripe_payment_intent_id',
];

function csvField(v: string | number | null | undefined): string {
  if (v === null || v === undefined) return '';
  const s = String(v);
  // Escape any double-quotes by doubling them; wrap in quotes when the
  // value contains a delimiter, quote, or newline.
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function ledgerToCsv(rows: LedgerRow[]): string {
  const lines: string[] = [HEADERS.join(',')];
  for (const { charge, family_name, dancer_name, allocated_cents } of rows) {
    const remaining = charge.amount_cents - allocated_cents;
    lines.push(
      [
        charge.id,
        charge.created_at,
        family_name,
        dancer_name ?? '',
        charge.category,
        charge.description,
        charge.amount_cents,
        allocated_cents,
        remaining,
        charge.due_date ?? '',
        charge.status,
        charge.stripe_invoice_id ?? '',
        charge.stripe_payment_intent_id ?? '',
      ]
        .map(csvField)
        .join(','),
    );
  }
  return lines.join('\n') + '\n';
}
